// API Configuration
const getApiConfig = () => {
  // Priority order for API URL:
  // 1. REACT_APP_API_URL (primary)
  // 2. REACT_APP_BACKEND_URL (fallback)
  // 3. localhost:8000 (development fallback)
  
  const apiUrl = process.env.REACT_APP_API_URL?.trim() || 
                 process.env.REACT_APP_BACKEND_URL?.trim()
                ;
                 
  return {
    API_URL: apiUrl.replace(/\/$/, ''), // Remove trailing slash
    buildApiUrl: (path = '') => {
      const baseUrl = apiUrl.replace(/\/$/, '');
      if (!path) return baseUrl;
      if (path.startsWith('/')) return `${baseUrl}${path}`;
      return `${baseUrl}/${path}`;
    }
  };
};

export const { API_URL, buildApiUrl } = getApiConfig();

// Auth headers helper
export const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token') || '';
  let tokenType = localStorage.getItem('token_type') || 'Bearer';
  tokenType = tokenType.charAt(0).toUpperCase() + tokenType.slice(1);
  return token 
    ? { 'Content-Type': 'application/json', Authorization: `${tokenType} ${token}` }
    : { 'Content-Type': 'application/json' };
};

export default {
  API_URL,
  buildApiUrl,
  getAuthHeaders
};



